export default "__VITE_ASSET__CXAp0Umc__"